// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3cLpz","actions":"GroupTable_actions__22A-k","deleteModalFooter":"GroupTable_deleteModalFooter__3J07A"};